<template>
  <div class="alarm-detail-page" v-loading="dataLoading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" :class="{ showDetail: !isShowRightPanel }">
    <div class="blur-bg map-blur-panel"></div>
    <div class="content" v-if="currentAlarmDetail">
      <div class="title">
        【{{ currentAlarmDetail.subSystemLabel }}】
        {{ currentAlarmDetail.alarmTypeLabel }}
      </div>
      <el-scrollbar class="ioc-alarm__scrollbar" style="height: calc(100% - 75px)">
        <!-- 图片展示 -->
        <div v-if="currentAlarmDetail.subSystem !== '12' &&
          currentAlarmDetail.subSystem !== '13' &&
          currentAlarmDetail.subSystem !== '14' &&
          currentAlarmDetail.alarmType !== '80103'
          ">
          <div style="width: 100%">
            <!-- 人员黑名单告警展示图片对比 -->
            <div class="pic" v-if="currentAlarmDetail.alarmSnapUrl || currentAlarmDetail.picUrl">
              <div v-if="currentAlarmDetail.alarmType == '50102'" class="flex-between" style="position: relative">
                <div class="black-pic">
                  <img class="lookPhoto" v-if="currentAlarmDetail.alarmSnapUrl || currentAlarmDetail.picUrl" :src="imgPath(
                    currentAlarmDetail.alarmSnapUrl || currentAlarmDetail.picUrl
                  )
                    " alt @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                  <span class="pic-title">抓拍人员</span>
                </div>
                <div class="black-pic">
                  <img class="lookPhoto" v-if="currentAlarmDetail.picFileId" :src="imgPath(currentAlarmDetail.picFileId)" alt @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                  <span class="pic-title">黑名单人员</span>
                </div>
                <span class="similarity-text">相似度{{ Number(currentAlarmDetail.similarity) / 100 }}%</span>
              </div>
              <div v-else>
                <el-carousel style="height: 120px; overflow: hidden">
                  <el-carousel-item v-for="item in (
                    currentAlarmDetail.alarmSnapUrl ||
                    currentAlarmDetail.picUrl ||
                    ''
                  ).split(',')" :key="item">
                    <!-- <h3 class="small">{{ item }}</h3> -->
                    <img class="lookPhoto" :src="imgPath(item)" style="width: 100%; height: 120px" alt @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <!-- <div v-else>
              <img class="noImg" :src="noImg" />
            </div> -->

            <div class="video-btn" v-if="currentAlarmDetail.subSystem !== '9' &&
              currentAlarmDetail.subSystem !== '11' &&
              currentAlarmDetail.subSystem !== '13' &&
              currentAlarmDetail.alarmType !='50103'
              ">
              <div class="btn border" @click="viewVideo('back')">
                <img src="../imageshw/video.png" alt="" />
                事件录像
              </div>
              <div class="btn border" @click="viewVideo('live')">
                <img src="../imageshw/live.png" alt="" />
                实时画面
              </div>
              <!-- <div class="btn" v-if="currentAlarmDetail.alarmType == '50101' ||
                currentAlarmDetail.alarmType == '50102'
                " @click="searchTrackDetails(currentAlarmDetail)">
                <img src="../imageshw/track.png" alt="" />
                查询轨迹
              </div> -->
            </div>
          </div>
        </div>
        <div v-else-if="currentAlarmDetail.subSystem == '13'">
          <img class="noImg" style="height: 160px; width: 100%" src="../../../common/assets/images/electricalFire.png" />
        </div>
        <div v-else-if="currentAlarmDetail.subSystem == '12'" style="margin-bottom: 10px">
          <img class="noImg" style="height: 160px; width: 100%" src="../images/sos.png" />
        </div>
        <!-- 内容 -->
        <div class="ioc_alarm_detail">
          <div style="flex: 1; display: flex; margin-bottom: 12px">
            <div v-for="item in tabs" :key="item.value" :class="['tab', activeName == item.value ? 'active' : '']" @click="handleTabsChange(item)">
              {{ item.name }}
            </div>
          </div>
          <div class="ioc-alarm__drawer__card" v-show="activeName == 0">
            <eventDetails :detail="currentAlarmDetail" :emergencyCardList="emergencyCardList" :alarmType="currentAlarmDetail.alarmType" ref="alarmDetails"></eventDetails>
          </div>
          <div class="detail-div" v-if="activeName == 1">
            <div v-if="currentAlarmDetail.alarmState == 4 || currentAlarmDetail.alarmState == 10
              ">
              <div class="detail-item" v-if="workerOrderList.length > 0">
                <el-scrollbar height="90%">
                  <el-timeline style="padding: 10px" class="timeLine">
                    <el-timeline-item v-for="(activity, index) in workerOrderList" :key="index" placement="top" :timestamp="activity.operateTime | moment">
                      <p class="action">
                        {{ $t("taskCenter.label.action") }}
                        {{ formatter(execute, activity.action) }}
                      </p>
                      <p>
                        {{ $t("taskCenter.label.operator")
                        }}{{ activity.operatorName || activity.operator }}
                      </p>

                      <p>催办执行人：{{ activity.executor }}</p>
                      <p class="word-break-all">
                        {{ $t("taskCenter.label.descs") }}{{ activity.desc }}
                      </p>
                      <el-row>
                        <el-col :span="8"> 相关文件 ：</el-col>
                        <el-col :span="24" style="margin: 12px 0">
                          <app-file-list-show :fileInfoList="activity.fileInfos" @enlargeImage="enlargeImage"></app-file-list-show>
                        </el-col>
                      </el-row>
                    </el-timeline-item>
                  </el-timeline>
                </el-scrollbar>
              </div>
              <div v-else class="table-empty" style="text-align: center">
                <img src="@/common/assets/images/empty.svg" />
                <p>{{ $t("base.label.empty") }}</p>
              </div>
            </div>
            <div class="form-div" @click="handleReport" v-else>
              尚未派发工单，点击派单处置
            </div>
          </div>
          <div class="device-content" v-if="activeName == 2">
            <el-table :data="deviceTableData" :option="deviceTableOption">
              <el-table-column prop="deviceName" label="设备名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="distance" label="距离" width="80">
                <template slot-scope="scope">
                  {{ Number(scope.row.distance).toFixed(2) }}m</template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <!--摄像机-->
                  <div v-if="scope.row.deviceMark == '18'" class="btnBox">
                    <el-tooltip class="item" effect="dark" content="实时画面" placement="top" popper-class="tooltip-draw">
                      <el-button type="text" @click="playVideo('live', scope.row)" icon="el-icon-camera">
                      </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="事件录像" placement="top" popper-class="tooltip-draw">
                      <el-button type="text" @click="playVideo('back', scope.row)" icon="el-icon-video-camera">
                      </el-button>
                    </el-tooltip>
                  </div>
                  <!--广播-->
                  <div v-else-if="scope.row.deviceMark == '26'" class="btnBox">
                    <el-tooltip class="item" effect="dark" content="播放音频" placement="top" popper-class="tooltip-draw">
                      <el-button type="text" @click="handleAudio(scope.row)" icon="iconfont-lunan icon-lunan-guangbo">
                      </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="远程喊话" placement="top" popper-class="tooltip-draw">
                      <el-button type="text" @click="handleCall(scope.row)" icon="el-icon-microphone">
                      </el-button>
                    </el-tooltip>
                  </div>
                  <!-- 闸机 -->
                  <div v-else-if="scope.row.deviceMark == '22'" class="btnBox">
                    <el-tooltip class="item" effect="dark" content="闸机" placement="top" popper-class="tooltip-draw">
                      <el-button type="text" class="iconfont-lunan icon-lunan-u20" @click="handleControl({ sceneCode: '20220916000167' })">
                      </el-button>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 操作按钮 -->
      </el-scrollbar>
      <div class="footer">
        <div v-if="currentAlarmDetail.alarmState == 5" class="ioc-alarm__drawer__btns">
          <el-button @click="handleCloseAlarm" type="info"> 取消 </el-button>
          <el-button @click="handleRoute(currentAlarmDetail.emergencyRecordCode)" type="primary">
            进入预案
          </el-button>
        </div>
        <div v-if="currentAlarmDetail.alarmState == 4 || currentAlarmDetail.alarmState == 6" class="ioc-alarm__drawer__btns">
          <el-button @click="handleCloseAlarm" type="info"> 取消 </el-button>
          <el-button v-auth="'/realTimeAlarm:update'" type="primary" @click="resetDispose">
            关闭事件
          </el-button>
        </div>
        <div v-else-if="currentAlarmDetail.alarmState != 4 &&
          currentAlarmDetail.alarmState != 5 &&
          currentAlarmDetail.alarmState != 6
          " class="ioc-alarm__drawer__btns">
          <el-button @click="handleCloseAlarm" type="info"> 取消 </el-button>
          <!-- 陌生人标记 -->
          <el-button v-if="currentAlarmDetail.alarmType == '50108'" @click="handleMarkAlarm" type="info">
            标记
          </el-button>

          <el-button type="primary" v-auth="'/realTimeAlarm:update'" @click="resetDispose">
            关闭事件
          </el-button>
          <el-button v-if="showYn()" @click="toPlan" type="primary"> 启动预案 </el-button>
        </div>
      </div>
    </div>
    <!-- 派单 -->
    <appPanel :width="350" class="app-panel" style="z-index: 2" transparent :isExpand="showReportPanel" :modal="false" @cancel="handleCloseReportPanel" title="
       派单
      ">
      <el-scrollbar style="height: 100%">
        <div class="panel-content">
          <el-form ref="refReportForm" :model="reportForm">
            <el-form-item label="工单名称" label-width="80px" prop="taskName">
              <el-input placeholder="请输入" readonly v-model="reportForm.taskName"></el-input>
            </el-form-item>
            <el-form-item label="执行要求" label-width="80px">
              <el-input type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入" v-model="reportForm.remark">
              </el-input>
            </el-form-item>
            <el-form-item label="执行人员" label-width="80px" prop="executeTeams" style="height: 0px" class="peopleItem">
              <div>
                <span type="text" style="font-size: 14px; cursor: pointer" class="el-icon-circle-plus-outline" @click="handleAddPeople">
                  添加</span>
                <span class="tip" v-if="showTip" style="font-size: 12px; color: #f56c6c; margin-left: 12px">*请添加执行人员</span>
              </div>
            </el-form-item>
            <el-form-item label="">
              <alarmTask ref="alarmTask" :alarm="currentAlarmDetail" @checkPerson="checkPersons" @deleteWorker="deleteWorker"></alarmTask>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>

      <div class="footer" slot="footer">
        <el-button type="info" @click="handleCloseReportPanel">取消</el-button>
        <el-button type="info" @click="handleSaveReportPanel">立即派发</el-button>
      </div>
    </appPanel>
    <!-- 轨迹消息 -->
    <appPanel :width="350" class="app-panel" style="z-index: 3" transparent :isExpand="showTrackPanel" :modal="false" @cancel="handleCloseTrackPanel" :title="drawType == 1 ? '车辆轨迹信息' : '人员轨迹信息'">
      <el-scrollbar style="height: 100%">
        <div class="track">
          <div v-for="(item, index) in drawDataList" :key="'time' + index" @click.stop="onGetTrajectory(item, index)" :class="[
              'trajectoryId' + index,
              'track__list',
              showDrawIndex == index ? 'track--checked' : '',
            ]">
            <!-- 时间轴 -->
            <div class="track__list__time">
              <div>
                <span>时间：</span>
                <span>{{ item.recordDate || item.date }}</span>
              </div>
              <span :class="showDrawIndex == index ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "></span>
            </div>
            <!-- 详细时间轨迹信息 -->
            <div v-for="(val, indexIner) in drawType == 2 ? item.points[0] : item.trailList" :key="indexIner" :class="'track__list__detail ' + (showDrawIndex == index ? 'expand' : 'collspand')
              ">
              <div style="width: 100%" v-if="indexIner < showDrawNum">
                <div class="detail-img">
                  <img :src="drawType == 2 ? val.face_img_url : imgPath(val.rimageUrl)" @click.stop="onHandlePosition(val)" class="detail-img__img" onerror="this.src='/images/theme/newDark/default.png'" />
                  <input type="checkbox" class="detail-img--check" :name="(drawType == 2 ? item.recordDate : item.date) + indexIner" @click.stop="
                      onHandleCheckedChange(
                        $event,
                        val,
                        drawType == 2 ? item.recordDate : item.date,
                        indexIner
                      )
                      " />
                </div>
                <div>
                  <span>时间：</span>
                  <span>{{ drawType == 2 ? val.recordTime4Sort.trim().split(" ")[1] : val.time }}</span>
                </div>
                <div v-if="drawType == 2">
                  <span>相似度：</span>
                  <span>{{ val.similarity }}%</span>
                </div>
              </div>
            </div>
            <div v-if="(drawType == 2 ? item.points[0] : item.trailList).length > showDrawNum
              " @click.stop="onGetMoreList" :class="'track__list__btn ' +
    (showDrawIndex == index
      ? 'track__list--expand'
      : 'track__list--collspand')
    ">
              <el-button size="mini" type="primary">查看更多</el-button>
            </div>
          </div>
        </div>
      </el-scrollbar>

      <div class="footer" slot="footer">
        <el-button @click="handleCloseTrackPanel">取消</el-button>
      </div>
    </appPanel>
    <!-- 标记 -->
    <appPanel :width="350" class="app-panel" style="z-index: 2" transparent :isExpand="showMarkPanel" :modal="false" @cancel="handleCloseMarkPanel" title="
       人员标记
      ">
      <el-scrollbar style="height: 100%">
        <div class="panel-content">
          <el-form ref="refMarkForm" :model="markForm" label-width="78px" :rules="rules">
            <el-form-item label="标记分类" prop="type">
              <el-cascader clearable style="width: 100%" v-model="markForm.type" ref="cascaderPanel" placeholder="请选择类型" :show-all-levels="false" :options="groupType" :props="cascaderProps"></el-cascader>
            </el-form-item>
            <el-form-item label="人员姓名" prop="name">
              <el-input placeholder="请输入" v-model="markForm.name"></el-input>
            </el-form-item>
            <el-form-item label="人员性别" prop="sex">
              <el-select v-model="markForm.sex" style="width: 100%" placeholder="请选择">
                <el-option v-for="item in sexType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker style="width: 100%" v-model="markForm.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input clearable v-model="markForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item label="证件类型" prop="credentialType">
              <el-select v-model="markForm.credentialType" style="width: 100%" placeholder="请选择证件类型">
                <el-option v-for="item in IDNoType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="credentialNumber">
              <el-input clearable :maxlength="18" v-model="markForm.credentialNumber" placeholder="请输入证件号码"></el-input>
            </el-form-item>
            <el-form-item label="标记原因">
              <el-input type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入原因" v-model="markForm.desc">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>

      <div class="footer" slot="footer">
        <el-button type="info" :loading="markBtn" @click="handleCloseMarkPanel">{{
          markBtn ? "提交中" : "取消"
        }}</el-button>
        <el-button type="primary" :loading="markBtn" @click="handleSaveMarkPanel">{{
          markBtn ? "提交中" : "确定"
        }}</el-button>
      </div>
    </appPanel>
    <!-- @enlargeResource="enlargeResource" -->
    <el-dialog :title="$t('realTimeAlarm.title.resourse')" :visible.sync="resourceDialogShow" width="540px " v-dialogDrag :close-on-click-modal="false" :destroy-on-close="true" :before-close="resourceClose">
      <!-- 该行数据currentResource，告警详情taskAlarmInfo都必须有 -->
      <resource-show ref="resourceDialog" :resourceUrl="currentResource" :alarmInfo="currentAlarmDetail"></resource-show>
    </el-dialog>
    <el-dialog title="轨迹" :visible.sync="mapTrackShow" :append-to-body="appendBody" v-dialogDrag width="68%" style="margin-top: 20px;">
      <appMap ref="refAppMap" class="map" divId="miniMap"></appMap>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import imgzn from "../imageshw/no-img.jpg";
import imgen from "../imageshw/Image not found.jpg";
import { Dic, Bus, Dates, Cache } from "$utils";
import eventDetails from "./alarmDetail";
import alarmTask from "../components/alarmTask";
import appFileListShow from "@src/components/business/app-file-list-show";
import appPanel from "@src/components/business/app-panel/index.vue";
import resourceShow from "@src/components/business/app-resource-show-alarm";
import appMap from "@src/components/common/gis/index";
export default {
  components: {
    eventDetails,
    appPanel,
    alarmTask,
    resourceShow,
    appFileListShow,
    appMap,
  },
  props: {
    currentAlarmDetail: {
      type: Object,
      default: () => {
        return null;
      },
    },
    workerOrderList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    deviceTableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isShowPanel: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  watch: {
    isShowPanel: {
      handler(newVal) {
        this.isShowRightPanel = newVal;
        if (newVal) {
          this.activeName = 0;
        } else {
          this.showReportPanel = false;
        }
      },
      immediate: true,
    },
    currentAlarmDetail: {
      deep: true,
      handler(val) {
        if (val && val.alarmType == "50108") {
          // 陌生人标记
          this.getBlackList();
        }
      },
      immediate: true,
    },
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      var reg = new RegExp("^1[3456789]\\d{9}$");
      if (!reg.test(value) && value) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    return {
      appendBody: true,
      mapTrackShow: false,
      markBtn: false,
      sexType: Dic.find("SENU018"),
      IDNoType: Dic.find("SENU028"),
      groupType: Dic.find("SENU027"),
      showMarkPanel: false,
      resourceDialogShow: false,
      currentResource: [],
      execute: Dic.find("SENU056"), // 执行动作
      showTrackPanel: false,
      showReportPanel: false,
      noImg: this.$i18n.locale === "zh_CN" ? imgzn : imgen,
      isShowRightPanel: false,
      dataLoading: false,
      activeName: 0,
      showTip: false,
      emergencyCardList: [],
      deviceTableOption: {
        index: false,
        indexLabel: "序号",
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        align: "left",
        size: "small",
        maxHeight: "200",
        menuWidth: 80,
        labelWidth: "100",
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        emptyText: "暂无数据",
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
          },
          {
            label: "距离 / m",
            prop: "distance",
            formatter: (row, value) => {
              return (value && Number(value).toFixed(1)) || "";
            },
          },
        ],
      },
      tabs: [
        { name: "事件详情", value: 0 },
        { name: "处置工单", value: 1 },
        { name: "关联设备", value: 2 },
      ],
      markForm: {
        type: "",
        name: "",
        sex: "",
        birthday: "",
        credentialType: "",
        credentialNumber: "",
        fileCode: "",
        phone: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择分类",
            trigger: ["blur", "change"],
          },
        ],
        credentialType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: ["blur", "change"],
          },
        ],
        credentialNumber: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: ["blur", "change"],
          },
        ],
        fileCode: [
          {
            required: true,
            message: "请上传图片",
            trigger: ["change"],
          },
        ],
        phone: [
          {
            required: false,
            trigger: ["change"],
            validator: validatePhone,
          },
        ],
      },
      distance: "30",
      reportForm: {
        code: "",
        desc: this.$t("realTimeAlarm.label.fastUp"),
        executeTeams: [
          {
            executor: [],
            executorName: [],
            accountType: [],
            accountGroupCodes: [],
          },
        ],
        fileInfos: [],
        groupCode: "",
        requiredFinishedTime: "",
        userFrom: "0",
        requiredStartTime: Dates.format(new Date()),
        taskAlarmWeb: {
          alarmId: "",
          alarmLevel: 0,
          alarmTime: "",
          alarmType: "",
          deviceName: "",
          subSystem: "",
        },
        taskName: "",
        taskPriority: 0,
        taskType: 1,
        taskVisibility: 2,
      },
      executeTeams: [], //选中的人员信息集合
      executeIdTeams: [], //选中的人员id集合
      chiocedPersonArr: [],
      drawType: 3,
      copyCheckboxGroupList: [],
      checkIdList: [],
      checkDrawList: [],
      checkDrawIdList: [],
      drawDataList: [],
      showDrawNum: 6, //默认展示轨迹初始数量，和【加载更多】btn搭配使用
      showDrawIndex: 0, //当前展开的轨迹下标位置
      constLayerId: {
        circles: "alarm-circles",
        line: "alarm-line",
      },
      cascaderProps: {
        children: "children",
        expandTrigger: "hover",
      },
      trackPoints: [],
      dayDate: Dates.format(new Date(), "yyyy-MM-dd"),
    };
  },
  mounted() {},
  methods: {
    getBlackList() {
      this.groupType.forEach((item, index) => {
        this.$set(this.groupType[index], "children", []);
      });
      this.$fetch(api.queryGroup).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return false;
        }
        res.returnObj.map((item1) => {
          this.groupType.map((item2) => {
            if (item1.type === item2.value) {
              item2.children.push({
                label: item1.name,
                value: item1.code,
              });
            }
          });
        });
      });
    },
    handleCloseMarkPanel() {
      this.showMarkPanel = false;
      this.$refs.refMarkForm.resetFields();
    },
    handleSaveMarkPanel() {
      this.$refs.refMarkForm.validate((res) => {
        if (res) {
          let params = { ...this.markForm };
          params.attachments = [
            {
              fileCode: this.currentAlarmDetail.alarmSnapUrl,
            },
          ];
          params.repositorCode = this.markForm.type[1];
          this.markBtn = true;
          this.$fetch(api.addPersonnelBwlist, params).then((res) => {
            this.markBtn = false;
            if (res.success) {
              this.$message.success("操作成功");
              this.handleCloseMarkPanel();
            } else {
              this.$message.error(res.msgContent || "操作失败");
            }
          });
        }
      });
    },
    // 陌生人标记
    handleMarkAlarm() {
      this.showMarkPanel = true;
    },
    handleAddPeople() {
      this.$refs.alarmTask.addWorkGroup();
    },
    handleAudio(info) {
      this.$emit("handleOpenBroadcast", info, 2);
    },
    handleCall(info) {
      this.$emit("handleOpenBroadcast", info, 1);
    },
    handleCloseAlarm() {
      this.isShowRightPanel = false;
      this.$emit("handleCloseAlarm");
    },
    // 加载更多
    onGetMoreList() {
      this.showDrawNum += 6;
    },
    // 选中/取消勾选图片，同时将已勾选所有图片轨迹信息绘制在地图上：showDrawTrajectory绘制方法
    onHandleCheckedChange(event, val, date, index) {
      let checkboxFlag = document.getElementsByName(date + index);
      if (checkboxFlag[0].checked) {
        // 选中状态
        this.checkDrawList.push(val);
        this.checkDrawIdList.push(
          this.drawType == 2 ? val.recordTime : val.fullTime
        );
      } else {
        // 取消选中
        let spliceIndex = this.checkDrawIdList.indexOf(
          this.drawType == 2 ? val.recordTime : val.fullTime
        );
        this.checkDrawList.splice(spliceIndex, 1);
        this.checkDrawIdList.splice(spliceIndex, 1);
      }
      this.showDrawTrajectory(this.checkDrawList);
    },
    onHandlePosition(val) {
      this.$map.MapInstance2D.positionByPoint([
        +val.lng || +val.longitude,
        +val.lat || +val.latitude,
      ]);
    },
    // 点击时间日期将暂时当前时间日期下的所有轨迹并销毁之前的一切操作：showDrawTrajectory绘制方法
    onGetTrajectory(item, index) {
      this.showDrawNum = 6;
      this.checkDrawList = [];
      this.checkDrawIdList = [];
      // 初始化img-input 选中状态
      let divs = document.querySelectorAll(".detail-img--check");
      [].forEach.call(divs, function (div) {
        div.checked = false;
      });
      this.$nextTick(() => {
        if (this.showDrawIndex == index) {
          this.showDrawIndex = "-1";
        } else {
          this.showDrawIndex = index;
          this.showDrawTrajectory(
            this.drawType == 2 ? item.points[0] : item.trailList
          );
        }
      });
    },
    handleCloseTrackPanel() {
      this.showTrackPanel = false;
      this.showDrawNum = 6;
      this.showDrawIndex = 0;
      this.checkDrawList = [];
      this.checkDrawIdList = [];
      this.$map.MapInstance2D.clearLayer(this.constLayerId.circles);
      this.$map.MapInstance2D.clearLayer(this.constLayerId.line);
    },
    // handleShowDraw(item) {
    //   this.copyCheckboxGroupList = [];
    //   this.checkIdList = [];
    //   this.drawType = 3;
    //   let startTime = new Date(Dates.format(item.alarmTime, "yyyy MM dd")).getTime();
    //   let endTime =
    //     new Date(Dates.format(item.alarmTime, "yyyy MM dd")).getTime() +
    //     24 * 60 * 60 * 1000;
    //   if (item.alarmType == "50101") {
    //     // 车辆
    //     let params = {
    //       area: [item.groupCode],
    //       plateCode: item.plateNo,
    //       startTime: Dates.parse(Dates.format(startTime)),
    //       endTime: Dates.parse(Dates.format(endTime)),
    //     };
    //     this.$fetch(api.searchCarDraw, params).then((res) => {
    //       if (res.success) {
    //         // 绘制轨迹
    //         if (!res.returnObj || !res.returnObj.length) {
    //           this.$message("暂无轨迹信息");
    //           return;
    //         }
    //         this.drawType = 1;
    //         this.drawDataList = res.returnObj[0].dateList || [];
    //         this.showTrackPanel = true;
    //         this.showDrawTrajectory(res.returnObj[0].dateList[0].trailList);
    //         this.$emit("handleLayer", { type: 0, value: false });
    //       } else {
    //         this.$message.error(res.msgContent);
    //       }
    //     });
    //   } else {
    //     // 人员
    //     let params = {
    //       pageNo: 1,
    //       pageSize: 100,
    //       fileId: item.alarmSnapUrl,
    //       areas: [item.groupCode],
    //       startTime: Dates.format(startTime, "yyyy-MM-dd HH:mm:ss"),
    //       endTime: Dates.format(endTime, "yyyy-MM-dd HH:mm:ss"),
    //       threshold: Number(Cache.get("SYS_YUZHI")),
    //       // faceSetId: ,//黑名单类型
    //       // 以下为测试数据
    //       // endTime: "2022-11-15 20:21:09",
    //       // fileId: "",
    //       // pageNo: 1,
    //       // pageSize: 100,
    //       // parkId: "200000001",
    //       // startTime: "2022-11-08 20:21:09",
    //       // threshold: 93,
    //     };
    //     this.$fetch(api.searchPeopleDraw, params).then((res) => {
    //       if (res.success) {
    //         if (!res.returnObj || !res.returnObj.length) {
    //           this.$message("暂无轨迹信息");
    //           return;
    //         }
    //         this.drawType = 2;
    //         // 绘制轨迹
    //         this.showTrackPanel = true;
    //         this.drawDataList = res.returnObj || [];
    //         this.showDrawTrajectory(res.returnObj[0].points[0]);
    //         this.$emit("handleLayer", { type: 0, value: false });
    //       } else {
    //         this.$message.error(res.msgContent);
    //       }
    //     });
    //   }
    // },
    searchTrackDetails(item) {
      let params = {
        pageNo: 1,
        pageSize: 100,
        fileId: item.filePicSourceLists[0].resourceCode,
        // startTime: this.dayDate + ' 00:00:00',
        // endTime: this.dayDate + ' 23:59:59',
        startTime: "2023-11-14 00:00:00",
        endTime: "2023-11-17 23:59:59",
        threshold: 80,
      };
      this.$fetch(
        "/vas/personnelControl/personnelSearching/peopleTrackDetails.json",
        params
      ).then((res) => {
        if (res.success) {
          if (!res.returnObj || !res.returnObj.length) {
            this.$message.warning("暂无轨迹信息");
            return;
          }
          this.mapTrackShow = true;
          this.$nextTick(() => {
            this.queryTrackPoints(res.returnObj[0].records);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    queryTrackPoints(item) {
      this.trackPoints = [];
      let pointsArr = [];
      for (let i = 0; i < item.length; i++) {
        pointsArr.push({
          point: [Number(item[i].lng), Number(item[i].lat)],
        });
      }
      let params = {
        parkName: "lunanzhiyao",
        navigationDataInfoList: pointsArr,
        isInDoor: false,
      };
      this.$fetch(api.queryCheckPoints, params).then((res) => {
        if (res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            if (res[i].points.length > 0) {
              for (let j = 0; j < res[i].points.length; j++) {
                this.trackPoints.push({
                  data: {
                    longitude: res[i].points[j][0],
                    latitude: res[i].points[j][1],
                  },
                });
              }
            }
          }
          // console.log('轨迹', this.trackPoints)
          this.trackPoints.shift();
          this.trackPoints.pop();
          // console.log('轨迹去重', this.trackPoints)
          this.handleShowDrawLine();
        } else {
          this.$message.error("轨迹查询失败");
        }
      });
    },
    handleShowDrawLine() {
      let pointCoord = []; //坐标集合
      let circleInfo = []; //标记集合
      let list = this.trackPoints;
      list.forEach((val, index) => {
        pointCoord.push([
          +val.data.longitude || +val.data.lng,
          +val.data.latitude || +val.data.lat,
        ]);
        circleInfo.push({
          longitude: +val.data.longitude || +val.data.lng,
          latitude: +val.data.latitude || +val.data.lat,
          radius: 15, //半径
          label:
            index == 0
              ? "起"
              : index == list.length - 1
              ? "终"
              : String(index + 1),
          outline: false, //是否显示轮廓线
          outlineWidth: 3,
          height: 10, //高度
          outlineColor: "#3E76E6", //轮廓线颜色
          fill: true, //是否填充颜色
          labFillColor: "#000000",
          fillColor:
            index == 0
              ? "rgba(112,181,4,1)"
              : index == list.length - 1
              ? "rgba(217,0,27,1)"
              : "#3E76E6", //颜色
          attr: {
            ...val.data,
            child: val.child,
          },
        });
      });
      console.log(pointCoord);
      //绘制轨迹信息并地图居中显示
      this.$refs.refAppMap.positionByPoint(pointCoord && pointCoord[0]);
      this.$refs.refAppMap.drawTrajectory(
        this.constLayerId.line,
        [
          {
            coord: pointCoord,
            id: "alarmTrackId",
            attr: list,
          },
        ],
        {
          isDirect: true,
        }
      );
      this.$refs.refAppMap.addCircles(
        circleInfo,
        this.constLayerId.circles,
        this.handleCircle
      );
    },
    showDrawTrajectory(item) {
      let drawItem = JSON.parse(JSON.stringify(item));
      let pointCoord = []; //坐标集合
      let circleInfo = []; //标记集合
      let dataInfo = {};
      // 根据时间排序showTime，recordTime
      if (this.drawType == 1) {
        drawItem.sort((a, b) => {
          a.showTime = this.filterTime(a.fullTime);
          var x = "showTime";
          var value1 = a[x];
          var value2 = b[x];
          return value1 - value2;
        });
        //合并相同项，相同经纬度轨迹合并展示
        drawItem.forEach((data, index) => {
          data.trajectoryType = "vehicle";
          let { longitude } = data;
          let { latitude } = data;
          if (!dataInfo[longitude] && !dataInfo[latitude]) {
            dataInfo[longitude] = {
              data,
              child: [],
            };
          }
          dataInfo[longitude].child.push(data);
        });
      } else {
        drawItem.sort((a, b) => {
          var x = "recordTime";
          var value1 = a[x];
          var value2 = b[x];
          return value1 - value2;
        });
        drawItem.forEach((data, index) => {
          let { lng } = data;
          let { lat } = data;
          if (!dataInfo[lng] && !dataInfo[lat]) {
            dataInfo[lng] = {
              data,
              child: [],
            };
          }
          dataInfo[lng].child.push(data);
        });
      }
      let list = Object.values(dataInfo);
      list.forEach((val, index) => {
        pointCoord.push([
          +val.data.longitude || +val.data.lng,
          +val.data.latitude || +val.data.lat,
        ]);
        circleInfo.push({
          longitude: +val.data.longitude || +val.data.lng,
          latitude: +val.data.latitude || +val.data.lat,
          radius: 15, //半径
          label:
            index == 0
              ? "起"
              : index == list.length - 1
              ? "终"
              : String(index + 1),
          outline: false, //是否显示轮廓线
          outlineWidth: 3,
          height: 10, //高度
          outlineColor: "#3E76E6", //轮廓线颜色
          fill: true, //是否填充颜色
          labFillColor: "#000000",
          fillColor:
            index == 0
              ? "rgba(112,181,4,1)"
              : index == list.length - 1
              ? "rgba(217,0,27,1)"
              : "#3E76E6", //颜色
          attr: {
            ...val.data,
            child: val.child,
          },
        });
      });
      console.log(pointCoord);
      //绘制轨迹信息并地图居中显示
      this.$map.MapInstance2D.positionByPoint(pointCoord && pointCoord[0]);
      this.$map.MapInstance2D.drawTrajectory(
        this.constLayerId.line,
        [
          {
            coord: pointCoord,
            id: "alarmTrackId",
            attr: list,
          },
        ],
        {
          isDirect: true,
        }
      );
      this.$map.MapInstance2D.addCircles(
        circleInfo,
        this.constLayerId.circles,
        this.handleCircle
      );
    },
    //轨迹点击回调
    handleCircle(e) {
      const tipID = "track_popup";
      let markerInfo = e.marker;
      console.log(e);
      // 挂载在vue实例上
      this.$map.MapInstance2D.addPopupMap({
        offset: [10, 10],
        position: markerInfo.coord,
        content: '<div id="track_popup">1231313</div>',
        contentId: tipID,
        layerId: tipID,
      });
      // trackDetail
      let tipVue = null;
      tipVue = new this.$map.MapInstance2D.vueComponents.trackTip().$mount(
        "#" + tipID
      );
      tipVue.handleSetData({
        ...markerInfo.attr,
      });
      tipVue.$on("tipClose", (e) => {
        this.$map.MapInstance2D.removePopup(tipID);
      });
    },
    // 启动预案
    toPlan() {
      const params = {
        alarmDevId: this.currentAlarmDetail.alarmDevId,
        alarmId: this.currentAlarmDetail.alarmId,
        alarmType: this.currentAlarmDetail.alarmType,
        latitude: this.currentAlarmDetail.lat,
        longitude: this.currentAlarmDetail.lng,
        status: "1",
      };
      this.$fetch(api.reserve.startEmergency, params).then((response) => {
        if (response.success) {
          this.handleRoute(response.returnObj);
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 查询区域所属安保
    getSecurityInfo() {
      this.$fetch("cms/workgroup/querySecurityInfoByArea.json", {
        groupCode: this.currentAlarmDetail.groupCode,
      }).then((res) => {
        if (res.success && res.returnObj) {
          let tempArr = [];
          tempArr = res.returnObj;
          this.chiocedPersonArr = tempArr.map((data) => {
            return {
              id: data.accountNumber,
              name: data.nickName,
            };
          });
          this.$nextTick(() => {
            //如果返回数据有安保则不push到alarmTask的executeTeams
            this.$refs.alarmTask.executeTeams =
              this.$refs.alarmTask.executeTeams.concat(this.chiocedPersonArr);
            var temp = [];
            this.$refs.alarmTask.executeTeams.forEach(function (a) {
              var check = temp.every(function (b) {
                return a.id !== b.id;
              });
              check ? temp.push(a) : "";
            });
            this.$refs.alarmTask.executeTeams = temp;
          });
        }
      });
    },
    // 显示资源
    enlargeResource(item) {
      this.resourceDialogShow = true;
      this.currentResource = [item];
    },
    // 周边设备的视频和录像
    playVideo(type, item) {
      this.$app.AppInstance.handleMiniPlay({
        playType: type,
        playTitle: item.deviceName, //摄像机名称
        playId: item.thirdDeviceId, //摄像机id
        startTime:
          this.currentAlarmDetail.startTime || new Date().getTime() - 60 * 1000, //如果没有时间默认最新一分钟
        endTime: this.currentAlarmDetail.endTime || new Date().getTime(),
      });
    },
    // 资源组件关闭
    resourceClose() {
      this.$refs.resourceDialog.stopVideo();
      this.resourceDialogShow = false;
    },
    enlargeImage(item) {
      this.resourceDialogShow = true;
      this.currentResource = [item];
    },
    formatter(dataList, value) {
      let rtn = "";
      dataList.map((item) => {
        if (item.value == value) {
          rtn = item.label;
        }
      });
      return rtn;
    },
    handleSaveReportPanel() {
      if (this.executeIdTeams.length === 0) {
        this.showTip = true;
        return;
      }
      this.$refs.refReportForm.validate((val) => {
        if (!val) {
          return;
        }
        this.reportForm.taskAlarmWeb.alarmId = this.currentAlarmDetail.alarmId;
        this.reportForm.taskAlarmWeb.alarmLevel =
          this.currentAlarmDetail.alarmLevel;
        this.reportForm.taskAlarmWeb.alarmTime = this.currentAlarmDetail
          .alarmTime
          ? Dates.dayjs(this.currentAlarmDetail.alarmTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : "";
        this.reportForm.taskAlarmWeb.alarmType =
          this.currentAlarmDetail.alarmType;
        this.reportForm.taskAlarmWeb.deviceName =
          this.currentAlarmDetail.deviceName;
        this.reportForm.taskAlarmWeb.subSystem =
          this.currentAlarmDetail.subSystem;
        this.reportForm.taskPriority = this.currentAlarmDetail.alarmLevel;
        this.reportForm.groupCode = this.currentAlarmDetail.groupCode;
        this.reportForm.status = 2; // 任务下发增加status字段，启动状态
        // 告警设备ID
        this.reportForm.taskAlarmWeb.alarmDevId =
          this.currentAlarmDetail.alarmDevId;
        this.reportForm.taskName = this.currentAlarmDetail.alarmName;
        // console.log(this.reportForm, '$$$')
        this.$fetch(api.bas.addTaskInfo, this.reportForm).then((response) => {
          if (response && response.success) {
            this.currentAlarmDetail.alarmState = 4;
            this.handleCloseReportPanel();
            // this.getList(this.page, this.queryParams);
            this.$emit("handleTaskInfoCallBack", this.currentAlarmDetail);
            this.$message.success(this.$t("realTimeAlarm.message.issueSuc"));
          } else {
            this.$message.error(response.msgContent);
          }
        });
      });
    },
    checkPersons(list) {
      this.executeTeams = [...list];
      this.showTip = list.length > 0 ? false : true;
      this.executeIdTeams = this.executeTeams.map((item) => {
        return item.id || item.workNo;
      });
      this.reportForm.executeTeams[0].executor = this.executeTeams.map(
        (item) => {
          return item.id || item.workNo;
        }
      );
      this.reportForm.executeTeams[0].executorName = this.executeTeams.map(
        (item) => {
          return item.name;
        }
      );
      this.reportForm.executeTeams[0].accountType = this.executeTeams.map(
        (item) => {
          if (item.id) {
            return 1;
          } else {
            return 2;
          }
        }
      );
      this.reportForm.executeTeams[0].accountGroupCodes = this.executeTeams.map(
        (item) => {
          return item.parentId;
        }
      );
    },
    deleteWorker(id) {
      if (this.executeIdTeams.indexOf(id) != -1) {
        this.executeIdTeams.splice(this.executeIdTeams.indexOf(id), 1);
        this.executeTeams.splice(this.executeIdTeams.indexOf(id), 1);
        this.showTip = this.executeIdTeams.length > 0 ? false : true;
      }
    },
    // 误报
    resetDispose() {
      this.$emit("resetDispose", "alarm");
    },
    // 跳转进入预案
    handleRoute(emergencyRecordCode = "") {
      this.$router.push({
        path: "/reserve/reserveProcess",
        query: {
          emergencyRecordCode: emergencyRecordCode,
        },
      });
    },
    // 只有一件求救/火灾/有毒有害气体显示预案
    showYn() {
      //烟火告警执行
      if (
        this.currentAlarmDetail.subSystem == 5 &&
        this.currentAlarmDetail.alarmType == "50107"
      ) {
        return true;
      }
      return Dic.find("SENU073005").some((el) => {
        return el.value == this.currentAlarmDetail.subSystem;
      });
    },
    handleCloseReportPanel() {
      this.showReportPanel = false;
      this.reportForm.remark = "";
      this.executeTeams = [];
      this.showTip = false;
      this.executeIdTeams = [];
      this.reportForm.executeTeams[0].executor = [];
      this.reportForm.executeTeams[0].executorName = [];
      this.reportForm.executeTeams[0].accountType = [];
      this.reportForm.executeTeams[0].accountGroupCodes = [];
      this.$refs.alarmTask.executeTeams = [];
    },
    handleReport() {
      this.showReportPanel = true;
      this.reportForm.taskName = this.currentAlarmDetail.alarmName;
    },
    handleTabsChange(item) {
      this.activeName = item.value;
    },
    // 告警详情的视频 录像
    viewVideo(type) {
      console.log(this.currentAlarmDetail);
      if (!this.currentAlarmDetail.thirdAlarmDevId) {
        this.$message.warning("无关联摄像机信息");
        return;
      }
      this.$app.AppInstance.handleMiniPlay({
        playType: type,
        playTitle: this.currentAlarmDetail.deviceName, //摄像机名称
        playId: this.currentAlarmDetail.thirdAlarmDevId, //摄像机id
        startTime:
          this.currentAlarmDetail.startTime || new Date().getTime() - 60 * 1000, //如果没有时间默认最新一分钟
        endTime: this.currentAlarmDetail.endTime || new Date().getTime(),
      });
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.alarm-detail-page {
  position: absolute;
  right: 0;
  width: 350px;
  height: 100%;
  z-index: 9;
  transition: right 0.3s;

  .content {
    width: 100%;
    height: calc(100% - 30px);
    margin: 20px 0px;
    position: absolute;

    .title {
      height: 16px;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      line-height: 16px;
      margin-bottom: 15px;
      padding-left: 10px;
    }

    .black-pic {
      width: 160px;
      height: 210px;
      position: relative;
      cursor: pointer;

      .pic-title {
        position: absolute;
        width: 100%;
        height: 40px;
        line-height: 40px;
        left: 0;
        text-align: center;
        bottom: 0;
        background-color: rgba(24, 31, 46, 0.65);
        color: #fff;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .video-btn {
      margin: 12px 0;
      height: 40px;
      @include set_theme_color(background-color, map-bg-color);
      display: flex;
      align-items: center;

      .btn {
        flex: 1;
        display: flex;
        justify-content: center;
        cursor: pointer;

        &:hover {
          color: #407aee;
        }

        img {
          margin-right: 6px;
        }
      }

      .border {
        border-right: 1px solid rgba(#fff, 0.1);
      }
    }

    .similarity-text {
      position: absolute;
      top: 105px;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90px;
      height: 90px;
      line-height: 30px;
      padding-top: 20px;
      text-align: center;
      border-radius: 50%;
      background-color: rgba(64, 122, 238, 0.65);
      color: #fff;
      font-size: 18px;
    }

    .ioc_alarm_detail {
      display: flex;
      flex-wrap: wrap;
      padding: 13px 10px;
      @include set_theme_color(background-color, map-bg-color);

      .tab {
        flex: 1;
        font-weight: bold;
        text-align: center;
        padding-bottom: 10px;
        border-bottom: 4px solid rgba(64, 122, 238, 0.2);

        &:hover {
          color: #407aee;

          cursor: pointer;
        }
      }

      .active {
        color: #407aee;
        border-color: #407aee;
      }

      .detail-div,
      .device-content {
        width: 100%;

        .form-div {
          cursor: pointer;
          margin: 50px;
          padding: 10px;
          border-radius: 5px;
          text-align: center;
          border: 1px solid rgba(193, 193, 193, 0.65);

          &:hover {
            color: #407aee;
            border-color: #407aee;
          }
        }

        .btnBox {
          display: flex;
          justify-content: space-between;

          button {
            font-size: 16px;
          }
        }
      }

      .timeLine {
        :deep .el-timeline-item__timestamp {
          // color: #ffffff;
        }

        :deep .el-timeline-item__content {
          // color: #ffffff;
          p {
            margin: 12px 0;
          }

          .action {
            position: absolute;
            top: -12px;
            right: 0;
            background: #407aee;
            color: #fff;
            padding: 4px 8px;
            border-radius: 5px;
          }
        }

        :deep .el-timeline-item__node {
          box-shadow: 0px 0px 5px 4px #407aee;
        }
      }
    }
  }

  .app-panel {
    .peopleItem {
      >>> .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    .track {
      height: calc(100% - 200px);

      &__list {
        display: flex;
        flex-flow: row wrap;
        padding: 10px;
        border-radius: 5px;
        position: relative;
        cursor: pointer;
        background: #1e2840;
        // @include set_theme_color(background-color, left-menu-bg-color);
        font-size: 12px;

        &__time {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }

        &__detail {
          display: flex;
          margin: 5px 5px;
          width: 32%;

          &.expand {
            height: 100%;
          }

          &.collspand {
            display: none;
          }

          .detail-img {
            position: relative;
            height: 0; // 设置高为0，让padding撑起高
            padding-bottom: 90%;
            margin-bottom: 10px;

            &__img {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
            }

            &--check {
              position: absolute;
              top: 5px;
              right: 5px;
            }
          }
        }

        &__btn {
          width: 100%;
          text-align: center;
        }

        &--expand {
          height: 100%;
          margin-bottom: 10px;
        }

        &--collspand {
          display: none;
        }

        &:hover {
          opacity: 0.8;
        }
      }

      &--checked {
        @include set_theme_color(border-color, main-theme-color);
        border: 1px solid;
      }
    }
  }
}

.showDetail {
  right: -350px !important;
}

.footer {
  text-align: center;
}
</style>
